import React from 'react'
import Widget, {CardHeader, CardTitle} from "./index";
import {useTranslation} from "react-i18next";
import {useAppSelector} from "../../redux/store";
import {FiPackage} from "react-icons/fi";
import {ButtonPrimary} from "../button";
import {TeamSubscription} from "../subscription";
import styled from "styled-components";
import {IconPlaceCircle} from "../modals/modal.info";
import {IconTeams2} from "../icons";
import {WidgetReferralsCard} from "./referrals";
import {Link} from "react-router-dom";
import {AlertInfoText} from "../alert";
import {useDashboard} from "../../service/api.swr";

const MAX_TEAMS_CARDS_CNT = 2

const WidgetTeamsCard = styled(WidgetReferralsCard)`

`

const TeamCards = styled.div`
  position: relative;
  width: 100%;
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(2, 1fr);
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    display: block;
    width: 1px;
    height: 100%;
    background-color: var(--it-stroke-grey);
  }
`

const TeamsCardHeader = styled(CardHeader)`
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
`

const TeamContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

const TeamHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const TeamName = styled.div`
  color: var(--it-text-white);
  /* H2 */
  font-family: "Druk Wide";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%; /* 20px */
  letter-spacing: -0.6px;
  text-transform: uppercase;
`

const TeamEmptyListCont = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
`

const MoreBtnCont = styled.div`
    
`

function TeamsEmptyList({}){
    const {t} = useTranslation();

    return (
      <TeamEmptyListCont>
        <AlertInfoText style={{marginTop: '0'}}>
          {t(`widget.teams.create_first_team`)}
        </AlertInfoText>

        <Link to={`/teams/team/add`} style={{marginTop: '20px'}}>
          <ButtonPrimary>
            <IconTeams2 size={20}/>
            {t(`widget.teams.btn_create_team`)}
          </ButtonPrimary>
        </Link>
      </TeamEmptyListCont>
    )
}

function TeamsItem({id, title, used_services, subscription, ...rest}) {
  const {t} = useTranslation();
  const { mutate: mutateDashboard } = useDashboard()

  return (
    <TeamContainer>
      <TeamHeader>
        <IconPlaceCircle style={{width: '56px', height: '56px', color: '#fff'}}>
          <IconTeams2 size={20}/>
        </IconPlaceCircle>

        <TeamName>{title}</TeamName>
      </TeamHeader>

      <TeamSubscription teamId={id}
                        {...subscription}
                        usedServices={used_services}
                        onSubscriptionUpdate={() => {
                          mutateDashboard();
                        }}
      />

    </TeamContainer>
  )
}

function TeamsList({data}){
    const {t} = useTranslation();

    return (
        <>
            {!data || data.length <= 0 ?
                <TeamsEmptyList />
                : (
                  <>
                    <TeamCards>
                      {/* reverse data - in order to get latest teams (by date change) from the list */}
                      {
                        data.toReversed().slice(0, MAX_TEAMS_CARDS_CNT).map((team, idx) => {
                          return <TeamsItem key={team.id} {...team} />
                        })
                      }
                    </TeamCards>
                  </>
                )
            }
        </>
    )
}

export const WidgetTeamsInfo = ({data, total, className = ''}) => {
    const {t} = useTranslation();
    const {user} = useAppSelector()

    return (
      <WidgetTeamsCard>
        <TeamsCardHeader>
          <CardTitle>{t('widget.teams.title')}</CardTitle>

          {
            data?.length > MAX_TEAMS_CARDS_CNT && (
              <MoreBtnCont>
                <Link to={`/teams/team`} style={{marginTop: '0'}}>
                  <ButtonPrimary>
                    <IconTeams2 size={20}/>
                    {t(`widget.teams.btn_more_teams`)}
                  </ButtonPrimary>
                </Link>
              </MoreBtnCont>
            )
          }
        </TeamsCardHeader>

        <TeamsList data={data} />
      </WidgetTeamsCard>
    )
}

